import React from 'react'

import { ZariContext } from '_zari/context'
import { Portlet, Row, Col, Button } from '_zari/core'

import { ZrSwal } from 'utils'

import * as AsientoContableService from 'services/asientosContables.service'

const portletBreadcrumbs = [
  { name: 'Estados Financieros' },
  { name: 'Cierre Clase 6-7-9' },
  { name: 'Generar asiento apertura siguiente año' }
]

const GenerarAperturaSiguienteAnoSection = () => {
  const __zariContext = React.useContext(ZariContext)

  const clickGenerarAsientosCierre = React.useCallback(() => {
    __zariContext.loader.open('Generando asientos de apertura.')

    AsientoContableService.validarAsientoAperturaNumeroOperacion1()
      .then(({ data }) => {
        if (data && data.existe) {
          ZrSwal.showAlert({
            mensaje: 'Se ha encontrado el asiento de apertura, desea sobreescribir?',
            showCerrar: true,
            onSuccess: () => {
              AsientoContableService.generarAsientoAperturaEnBaseACierreAnoAnterior()
                .then(() => {
                  __zariContext.snack('success', 'Asientos de apertura del siguiente año generado.')
                })
                .catch(({ data: { error } }) => __zariContext.snack('error', error))
                .finally(() => {
                  __zariContext.loader.close()
                })
            },
            tipo: 'warning'
          })
        } else {
          AsientoContableService.generarAsientoAperturaEnBaseACierreAnoAnterior()
            .then(() => {
              __zariContext.snack('success', 'Asientos de apertura del siguiente año generado.')
            })
            .catch(({ data: { error } }) => __zariContext.snack('error', error))
            .finally(() => {
              __zariContext.loader.close()
            })
        }
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext])

  return (
    <Portlet>
      <Portlet.Header title='Estados Financieros' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        <Row>
          <Col md={12}>
            <Button onClick={clickGenerarAsientosCierre} tiny>
              Generar asiento apertura siguiente año
            </Button>
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(GenerarAperturaSiguienteAnoSection)
